import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { TrackerComponent } from '../../../../../pages/network/tracker/tracker.component';
import { TrackerDetailsComponent } from '../../../../../pages/network/tracker-details/tracker-details.component';
import { TrackerDetailsOverviewComponent } from '../../../../../pages/network/tracker-details/tracker-details-overview/tracker-details-overview.component';
import { TrackerDetailsTrackedVisitorsComponent } from '../../../../../pages/network/tracker-details/tracker-details-tracked-visitors/tracker-details-tracked-visitors.component';

export const tracker: Route = {
  path: 'tracker',
  title: 'nav.network.tracker',
  data: {
    breadcrumb: 'nav.network.tracker',
    icon: SbIcons.tracker,
    id: RoutingID.tracker,
  },
  children: [
    {
      path: '',
      component: TrackerComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'tracker-details/:trackerID',
      title: 'nav.network.tracker.details',
      data: {
        breadcrumb: 'nav.network.tracker.details',
        icon: SbIcons.details,
        id: RoutingID.trackerDetails,
      },
      children: [
        {
          path: '',
          component: TrackerDetailsComponent,
          data: {
            breadcrumb: '',
          },
          children: [
            {
              path: 'tracker-details-overview',
              component: TrackerDetailsOverviewComponent,
              title: 'nav.network.devices.details.overview',
              data: {
                breadcrumb: 'nav.network.devices.details.overview',
                icon: SbIcons.eye,
                id: RoutingID.trackerDetailsOverview,
              },
            },
            {
              path: 'tracker-details-tracked-visitors',
              component: TrackerDetailsTrackedVisitorsComponent,
              title: 'nav.network.devices.details.visitors',
              data: {
                breadcrumb: 'nav.network.devices.details.visitors',
                icon: SbIcons.tracker,
                id: RoutingID.trackerDetailsTrackedVisitors,
              },
            },
            { path: '', redirectTo: RoutingID.trackerDetailsOverview, pathMatch: 'full' },
          ],
        },
      ],
    },
  ],
};
